import type { KyInstance } from 'ky';

import { ensureError, isDefined } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { User } from './types/user.type';

/**
 * Fetches the list of users.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param isActive - Optional active-status filter (server returns all users when omitted;
 *   `true` = active only, `false` = inactive only).
 * @returns OperationResultWithData wrapping `User[]`.
 */
export const getUsers = async (instance: KyInstance, isActive?: boolean) => {
  try {
    return await instance
      .get<OperationResultWithData<User[]>>(Uri.users.base, {
        searchParams: isDefined(isActive) ? { isActive } : undefined,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
